<template>
  <div class="join">
    <detailsTop :topIndex="topIndex" />
    <div class="news-content">
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          :bannerIndex="3"
          @changeTips="changeTips"
        />

        <div class="new-article">
          <div class="info-title">
            <div class="info-left"></div>
            <div class="info-right">经销加盟</div>
          </div>
          <div class="info-line"></div>

          <!-- <div>本着资源整合、优势互补、相互借力、双赢共利的原则，本公司欢迎广大志同道和者加盟</div> -->

          <div class="info-concent">
            <div
              ref="qqMap"
              id="container"
              style="width: 687px; height: 252px"
            ></div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                margin-left: 2.5%;
              "
            >
              <div class="contact-right">
                <el-image
                  class="operate-img"
                  :src="require('@/assets/images/phone-item.png')"
                ></el-image>
                &nbsp; &nbsp;&nbsp;
                <div>电话：{{ userInfo.tel }}</div>
              </div>

              <div class="contact-right">
                <el-image
                  class="operate-img"
                  :src="require('@/assets/images/emailcode-item.png')"
                ></el-image>
                &nbsp; &nbsp;&nbsp;
                <div>邮编：{{ userInfo.postalCode }}</div>
              </div>

              <div class="contact-right">
                <el-image
                  class="operate-img"
                  :src="require('@/assets/images/email-item.png')"
                ></el-image>
                &nbsp; &nbsp;&nbsp;
                <div>邮箱：{{ userInfo.mailbox }}</div>
              </div>

              <div class="contact-right">
                <el-image
                  class="operate-img"
                  :src="require('@/assets/images/address-item.png')"
                ></el-image>
                &nbsp; &nbsp;&nbsp;
                <div style="width: 100%; text-align: left">
                  地址：{{ userInfo.address }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { getTAboutUsInfo } from "@/api/api.js";

export default {
  name: "news",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: 6,
      bannerIndex: 2,
      userInfo: "",
    };
  },
  mounted() {
    this.initQQMap();
  },
  created() {
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));

    this.$route.query.bannerIndex
      ? (this.bannerIndex = this.$route.query.bannerIndex)
      : (this.bannerIndex = 0);
    this.$route.query.topIndex
      ? (this.topIndex = this.$route.query.topIndex)
      : (this.topIndex = 6);
    this.getTAboutUsInfo();
  },
  methods: {
    async getTAboutUsInfo() {
      const { data } = await getTAboutUsInfo();
      this.userInfo = data.data;
    },
    changeTips(index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "contactUS",
            query: { bannerIndex: index },
          });
          break;

        case 1:
          this.$router.push({
            name: "aftersales",
            query: { bannerIndex: index },
          });

          break;
        case 2:
          this.$router.push({ name: "support", query: { bannerIndex: index } });

          break;
        case 3:
          this.$router.push({ name: "join", query: { bannerIndex: index } });
          break;
        case 4:
          this.$router.push({ name: "message", query: { bannerIndex: index } });
          break;
      }
      localStorage.setItem("bannerList", JSON.stringify(this.bannerTipsList));
    },

    async initQQMap() {
      const { data } = await getTAboutUsInfo();
      this.userInfo = data.data;
      this.longitude = data.data.latitude;
      this.latitude = data.data.longitude;
      var center = new TMap.LatLng(this.longitude, this.latitude);
      var map = new TMap.Map(this.$refs.qqMap, {
        center: center, // 设置地图中心点坐标
        zoom: 12, // 设置地图缩放级别
        viewMode: "2D",
        showControl: false,
      });
      var marker = new TMap.MultiMarker({
        map: map,
        styles: {
          // 点标记样式
          marker: new TMap.MarkerStyle({
            width: 20, // 样式宽
            height: 30, // 样式高
            anchor: { x: 10, y: 30 }, // 描点位置
          }),
        },
        geometries: [
          // 点标记数据数组
          {
            // 标记位置(纬度，经度，高度)
            position: center,
            id: "marker",
          },
        ],
      });
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;


  .new-center {
    // flex: 5.3;
    background: #f4f4f4;
    .new-article {
      margin: 20px 0;
      height: 565px;
      background: #ffffff;
      width: 100%;
      min-height: 400px;

      .info-title {
        display: flex;
        align-items: center;
        padding-top: 25px;
        padding-left: 26px;

        .info-left {
          width: 5px;
          height: 28px;
          background: #46739f;
        }

        .info-right {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          margin-left: 16px;
        }
      }

      .info-line {
        width: 96%;
        margin: 0 auto;
        height: 1px;
        background: #eeeeee;
        margin-top: 25px;
      }

      .info-concent {
        padding-left: 26px;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        margin-top: 25px;
        margin-right: 10px;
        width: 72%;
        margin: 7% auto;
        display: flex;
        justify-content: space-between;

        .contact-right {
          display: flex;
          align-items: center;
        }
      }
    }
    .exhibition-item-info {
      width: 100%;
      background: #ffffff;
      margin-top: 23px;
      height: 565px;
      text-align: left;

      .info-title {
        display: flex;
        align-items: center;
        padding-top: 25px;
        padding-left: 26px;

        .info-left {
          width: 5px;
          height: 28px;
          background: #46739f;
        }

        .info-right {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          margin-left: 16px;
        }
      }

      .info-line {
        width: 96%;
        margin: 0 auto;
        height: 1px;
        background: #eeeeee;
        margin-top: 25px;
      }

      .info-concent {
        padding-left: 26px;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        margin-top: 25px;
        margin-right: 10px;
      }

      .info-table {
        width: 90%;
        margin: 4% auto;
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
        align-items: center;

        .table-title {
          width: 20%;
          height: 54px;
          line-height: 54px;
          background: #f4f4f4;
          text-align: center;
          border: 1px solid #e0e0e0;
        }

        .table-content {
          width: 29.6%;
          height: 54px;
          line-height: 54px;
          text-align: center;
          background: #ffffff;
          border: 1px solid #e0e0e0;
        }
      }
    }
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {


  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }


}
</style>
